import React, { useState } from "react";
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import styles from "./DynamicDropdownButton.module.scss";

const DynamicDropdownButton = ({
    buttonName,
    dropdownOptions,
    onOptionSelect,
}) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectedLabel, setSelectedLabel] = useState(buttonName);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handleOptionClick = (option) => {
        setSelectedLabel(option.label);
        onOptionSelect(option);
        setDropdownOpen(false);
    };

    return (
        <Dropdown
            isOpen={dropdownOpen}
            toggle={toggleDropdown}
            className={styles.dropdown}
        >
            <DropdownToggle
                caret
                className={`${styles.dropdownToggle} ${dropdownOpen ? styles.caretUp : styles.caretDown}`}
            >
                {selectedLabel}
            </DropdownToggle>
            <DropdownMenu className={styles.dropdownMenu}>
                {dropdownOptions.map((option, index) => (
                    <DropdownItem
                        key={index}
                        onClick={() => handleOptionClick(option)}
                        className={styles.dropdownItem}
                    >
                        {option.label}
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </Dropdown>
    );
};

export default DynamicDropdownButton;